import useSearchUserContact from "@/hooks/useSearchUserContact";
import { ChangeEvent, KeyboardEvent, useState } from "react";

const useFilterInput = (
    values: string[],
    setValues: (values: string[]) => void,
    validator?: (value: string) => boolean,
    getUnavailableReason?: (value: string) => string | undefined,
) => {
    const [newKeyword, setNewKeyword] = useState("");
    const [wrongInput, setWrongInput] = useState(false);
    const { debouncedSearchUserContact, suggestions, setSuggestions } =
        useSearchUserContact();

    const handleSearchUserContact = async (keyword: string) => {
        await debouncedSearchUserContact(keyword);
    };

    const addValue = (value: string) => {
        if (getUnavailableReason?.(value)) {
            setWrongInput(true);

            return false;
        }

        if (values.includes(value)) {
            setNewKeyword("");
            setWrongInput(false);

            return true;
        }

        if (!validator || validator(value)) {
            setValues(values.concat(value));
            setNewKeyword("");
            setWrongInput(false);

            return true;
        }

        setWrongInput(true);

        return false;
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setNewKeyword(value);
        handleSearchUserContact(value);

        if (value.endsWith(",")) {
            const valueToAdd = value.slice(0, -1);
            addValue(valueToAdd);
        } else {
            setWrongInput(false);
        }
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter" && newKeyword) {
            addValue(newKeyword);
        }
    };

    const handleBlur = () => {
        if (newKeyword) {
            addValue(newKeyword);
        }
    };

    const handleSuggestionSelect = (suggestion: string) => {
        addValue(suggestion);
        setSuggestions([]);
    };

    return {
        newKeyword,
        wrongInput,
        suggestions,
        handleChange,
        handleKeyDown,
        handleBlur,
        handleSuggestionSelect,
    };
};

export default useFilterInput;
